/**
 * Used as a the shared callback value when using built-in SSO options such as Google, Facebook, etc.
 * where the client session is decoded under a known pre-configured domain and then redirected to the appropriate network
 * based on the session state.
 */
export const SSO_FORWARDER_PATH = '/ssos/forward'

/**
 * Where the callback from built-in OAuth2 providers (Google, Facebook, etc.) as well as custom providers will be handled.
 */
export const SSO_CALLBACK_PATH = '/ssos/redirect'

/**
 * Where the callback from SAML providers will be handled.
 */
export const SSO_SAML_CALLBACK_PATH = '/api/auth/saml'

/**
 * I know. The `sso` in `/api/auth/sso` is a generic term, but it’s a legacy thing and the path only handlesJWT authentication.
 */
export const SSO_JWT_CALLBACK_PATH = '/api/auth/sso'

/**
 * Where the login form posts to start an SSO flow; the response redirects to the identity provider.
 */
export const SSO_LOGIN_PATH = '/api/auth/login'

/**
 * Browser-binding secret for the API's SSO flow record. Only its sha256 is sent at
 * initiation; the callback forwards the raw value. `__Host-`: Secure, Path=/, no Domain.
 */
export const SSO_BINDING_COOKIE = '__Host-bm_sso'

/** Post-login destination; the opaque `state` cannot carry it. */
export const SSO_REDIRECT_COOKIE = '__Host-bm_sso_redirect'

/** Matches the API flow record TTL. `setCookie` takes milliseconds. */
export const SSO_FLOW_COOKIE_MAX_AGE = 10 * 60 * 1000
